import React, { useEffect, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CheckCircleIcon } from 'lucide-react';
const BENEFITS = ['Acceso completo a todas las funciones', 'Embudos de venta ilimitados', 'Chat centralizado (WhatsApp, email, SMS)', 'Automatizaciones y workflows', 'App móvil incluida', 'Soporte personalizado'];
export function PruebaGratuita() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-valuan-blue selection:text-white" data-id="element-234">
      <Navbar data-id="element-235" />
      <main className="px-4 md:px-8 py-12 md:py-20 max-w-6xl mx-auto" data-id="element-236">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-237">
          {/* Title — always first */}
          <div className="flex flex-col justify-center order-1 lg:order-1 lg:row-span-2" data-id="element-238">
            <span className="inline-block text-[#F77730] font-semibold text-sm tracking-wide uppercase mb-4" data-id="element-239">
              Sin tarjeta de crédito
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6" data-id="element-240">
              Prueba Valuan CRM{' '}
              <span className="text-[#1F46D5]" data-id="element-241">gratis por 7 días</span>
            </h1>

            {/* Description — hidden on mobile, shown on desktop inline */}
            <div className="hidden lg:block" data-id="element-242">
              <p className="text-gray-600 text-lg leading-relaxed mb-10 max-w-md" data-id="element-243">
                Descubre cómo centralizar tu marketing, ventas y operaciones en
                una sola plataforma. Sin compromisos, sin complicaciones.
              </p>
              <ul className="space-y-4" data-id="element-244">
                {BENEFITS.map(b => <li key={b} className="flex items-center gap-3" data-id="element-245">
                    <CheckCircleIcon className="w-5 h-5 text-[#1F46D5] flex-shrink-0" data-id="element-246" />
                    <span className="text-gray-700" data-id="element-247">{b}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Form — second on mobile, right column on desktop */}
          <div className="bg-[#F4F5F7] rounded-3xl p-6 md:p-10 shadow-sm order-2 lg:order-2" data-id="element-248">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-249">
              Regístrate ahora
            </h2>
            <p className="text-gray-500 text-sm mb-8 text-center" data-id="element-250">
              Completa el formulario y activa tu prueba gratuita
            </p>
            <iframe src="https://api.leadconnectorhq.com/widget/form/vUOkr3ei21t9ZwvmuENc" style={{
            width: '100%',
            border: 'none',
            overflow: 'hidden'
          }} scrolling="no" id="inline-vUOkr3ei21t9ZwvmuENc" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Prueba Gratuita" data-height="600" data-layout-iframe-id="inline-vUOkr3ei21t9ZwvmuENc" data-form-id="vUOkr3ei21t9ZwvmuENc" title="Prueba Gratuita Valuan CRM" className="min-h-[600px] rounded-xl" data-id="element-251" />
          </div>

          {/* Description — shown on mobile after form, hidden on desktop */}
          <div className="lg:hidden order-3" data-id="element-252">
            <p className="text-gray-600 text-lg leading-relaxed mb-10 max-w-md" data-id="element-253">
              Descubre cómo centralizar tu marketing, ventas y operaciones en
              una sola plataforma. Sin compromisos, sin complicaciones.
            </p>
            <ul className="space-y-4" data-id="element-254">
              {BENEFITS.map(b => <li key={b} className="flex items-center gap-3" data-id="element-255">
                  <CheckCircleIcon className="w-5 h-5 text-[#1F46D5] flex-shrink-0" data-id="element-256" />
                  <span className="text-gray-700" data-id="element-257">{b}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </main>
      <Footer data-id="element-258" />
    </div>;
}